import { superadminApi } from '@/api/superadmin'
import RosterImporter from '@/features/admin/import/RosterImporter'
import { X } from 'lucide-react'

interface Props {
  tenant: { id: string; name: string }
  onClose: () => void
}

export default function ImportTenantModal({ tenant, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 p-4 overflow-y-auto">
      <div className="relative my-8 w-full max-w-2xl">
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 rounded-full bg-white p-1.5 text-gray-500 shadow hover:text-gray-700 cursor-pointer"
        >
          <X size={16} />
        </button>
        <p className="mb-2 text-sm font-medium text-white">Importing into <span className="font-semibold">{tenant.name}</span></p>
        <RosterImporter
          upload={(file, dryRun) => superadminApi.importTenantRoster(tenant.id, file, dryRun).then(r => r.data)}
        />
      </div>
    </div>
  )
}
